import Vue from 'vue'
import App from './App'
import store from './store' 
import router from './router'

import VModal from 'vue-js-modal'
Vue.use(VModal)
import { ModelSelect } from "vue-search-select";
Vue.component('model-select', ModelSelect)
import 'vue-search-select/dist/VueSearchSelect.css'
import VueResource from 'vue-resource'; //provides services for making web requests and handle responses using a XMLHttpRequest or JSONP.
Vue.use(VueResource);
import Spinner from 'vue-simple-spinner'
Vue.component('vue-simple-spinner', Spinner)
import browserDetect from "vue-browser-detect-plugin"
Vue.use(browserDetect)
import Vidle from 'v-idle'
Vue.use(Vidle)
import interceptorsSetup from './interceptors'
interceptorsSetup()

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
import { faSignInAlt, faSignOutAlt , faCalendarTimes, faTimes, faEye, faCheck, faMinusSquare, faPlusSquare, faAngleUp, faAngleDown} from '@fortawesome/free-solid-svg-icons'
library.add(faSignInAlt, faSignOutAlt, faCalendarTimes, faTimes, faEye, faTimes, faCheck, faMinusSquare, faPlusSquare, faAngleUp, faAngleDown)

import loginLayout from './loginLayout'
import deflayout from './deflayout'
Vue.component('deflayout', deflayout);
Vue.component('loginLayout', loginLayout);

Vue.config.productionTip = false
const vue = new Vue({
  router,
  store,
  render: h => h(App),
  components: { App }
})

vue.$mount('#app')